// extracted by mini-css-extract-plugin
module.exports = {"animate":"ErrorModal_animate__Ssx5b","error-modal":"ErrorModal_error-modal__wUv6y"};